// extracted by css-extract-rspack-plugin
var _1 = "nB2JqnV6VLklVcVx";
var _2 = "nB2JqnV6VLklVcVx";
var _3 = "A6nEs9iq9skq1PbQ";
var _4 = "A6nEs9iq9skq1PbQ";
var _5 = "GaIaqEoGwcUHpv9A";
var _6 = "GaIaqEoGwcUHpv9A";
var _7 = "uJjTcaFY0h68llhS";
var _8 = "uJjTcaFY0h68llhS";
var _9 = "sK8ydI3031Y1G3M7";
var _a = "Y2VBUBOP0Mse4A3Z";
var _b = "tVda5oQYsU0C5URK";
var _c = "xvmkrLa36QMoWB3b";
var _d = "xvmkrLa36QMoWB3b";
var _e = "tVda5oQYsU0C5URK";
var _f = "YFqHTS4s0EI7zVMf";
var _10 = "BClern2BNbYvbU3m";
var _11 = "HZGOITl3lMQFxEqg";
var _12 = "YFqHTS4s0EI7zVMf";
var _13 = "BClern2BNbYvbU3m";
var _14 = "HZGOITl3lMQFxEqg";
var _15 = "Ho6ItmjkEwAaO683";
var _16 = "Ho6ItmjkEwAaO683";
var _17 = "ioSrngwf7JY1u8kt";
var _18 = "ioSrngwf7JY1u8kt";
export { _1 as "divider-element", _2 as "dividerElement", _3 as "draw-time", _4 as "drawTime", _5 as "goal-event", _6 as "goalEvent", _7 as "matcheventContainer", _8 as "matchevent__container", _9 as "matchevents", _a as "post", _b as "post--with-star-author", _c as "post-neutral", _d as "postNeutral", _e as "postWithStarAuthor", _f as "social--facebook", _10 as "social--instagram", _11 as "social--twitter", _12 as "socialFacebook", _13 as "socialInstagram", _14 as "socialTwitter", _15 as "var-event", _16 as "varEvent", _17 as "with-author", _18 as "withAuthor" }
